import { StyleSheet, Platform } from 'react-native'

export const styles = StyleSheet.create({
  container: {
    // maxWidth: '100%',
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    width: '100%',
    marginTop: 10,
    marginBottom: 34,
    flex: 1,
    // backgroundColor: 'pink',
    // flexShrink: 1,
  },
  paragraph: {
    marginBottom: 10,
  },
  img: {
    alignSelf: 'center',
  },
  button: {
    // marginTop: 'auto',
    // marginBottom: 60,
    marginVertical: 20,
  },
  note: {
    marginTop: 20,
  },
  listIcon: {
    marginRight: 5,
  },
  title: {
    marginVertical: 20,
    width: '80%',
    alignSelf: 'center',
  },
  listTitle: {
    marginBottom: 10,
  },
  section: {
    marginVertical: 20,
    // flex: 1,
    // flexShrink: 1,
  },
  sectionTitle: {
    marginBottom: 10,
  },
  sectionItem: {
    marginLeft: 20,
    marginBottom: 20,
    flexDirection: 'row',
    alignItems: 'flex-start',
    // flexWrap: 'wrap',
  },
  sectionNumber: {
    minWidth: 30,
  },
  sectionNote: {
    marginLeft: 50,
    marginBottom: 20,
  },
  // sectionFooter: {
  //   marginBottom: 10,
  // },
  descriptionContainer: {
    marginTop: 20,
    marginBottom: 10,
  },
});

export default styles;